import { axiosPrivate } from "../api/axiosCore";

const limit = 20;
const ALL_DEPT = "Access_All_Dept";
const OWN_DEPT = "Access_Own_Dept";
const OWN = "Access_Own";
const BOT_ID = "3ef9f486-ddad-46ed-b568-f7b32a62262f";

export const updateChatAdminReadCount = async (token, chatId, unreadCountAdmin) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    const response = await axiosPrivate.put(
      "api/chats/" + chatId,
      JSON.stringify({ unreadCountAdmin: unreadCountAdmin }),
    );

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const updateChatReadCount = async (token, chatId, unreadCount) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    const response = await axiosPrivate.put("api/chats/" + chatId, { unreadCount: unreadCount });
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const servicePutChat = async (token, chatId, data) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Content-Type"] = "application/json";
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    const response = await axiosPrivate.put("api/chats/" + chatId, data);
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

function getParamStatus(roleName) {
  let paramStatus = "status";
  switch (roleName) {
    case "CS":
      paramStatus = "csStatus";
      break;
    case "HEAD":
      paramStatus = "headStatus";
      break;
    case "ADMIN":
      paramStatus = "adminStatus";
      break;
    case "SUPER ADMIN":
      paramStatus = "superStatus";
      break;
    case "SYSTEM ADMIN":
      paramStatus = "sysAdminStatus";
      break;

    default:
      break;
  }
  return paramStatus;
}

export const serviceGetChats = async (
  token,
  userId,
  departmentId,
  status,
  tagId,
  roleFunctions,
  roleName,
  filterUserId,
  campaignIds = "",
  channelIds = "",
  filterDepartmentIds = "",
  dateFrom = "",
  dateTo = "",
) => {
  const basicUrl = `api/chats?take=${limit}&order=DESC&fo=chat.updatedAt`;
  axiosPrivate.interceptors.request.use((config) => {
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  });
  let paramTagId = "";
  let paramUserId = "";
  let paramStatus = "";
  let paramCampaignIds = "";
  let paramChannelIds = "";

  if (channelIds !== "" && channelIds !== undefined) {
    paramChannelIds = "&channelIds=" + channelIds;
  }

  if (status) {
    paramStatus = "&" + getParamStatus(roleName) + "=" + status;
  }

  if (status && status === "CHATBOT" && roleFunctions.includes("View_Chatbot")) {
    paramStatus = "&userId=" + BOT_ID;
  }

  if (tagId !== "" && tagId !== undefined) {
    paramTagId = "&tagIds=" + tagId;
  }

  if (filterUserId !== "" && filterUserId !== undefined) {
    paramUserId = "&userId=" + filterUserId;
  }

  if (campaignIds !== "" && campaignIds !== undefined) {
    paramCampaignIds = "&campaignIds=" + campaignIds;
  }

  let paramDate = "";

  if (dateFrom !== "" && dateFrom !== undefined) {
    paramDate += "&dateFrom=" + dateFrom;
  }

  if (dateTo !== "" && dateTo !== undefined) {
    paramDate += "&dateTo=" + dateTo;
  }

  let response = null;
  let excludeBot = "";

  //jika CS atau SALES, exclude bote is true
  if (!roleFunctions.includes("View_Chatbot")) {
    excludeBot = "&excludeBot=true";
  }

  // Filter by department: for ALL_DEPT it adds a departmentIds param,
  // for OWN_DEPT/OWN it narrows the mandatory departmentIds to the selection
  let paramDepartmentIds = "";

  if (filterDepartmentIds !== "" && filterDepartmentIds !== undefined) {
    paramDepartmentIds = "&departmentIds=" + filterDepartmentIds;
  }

  const ownDepartmentIds =
    filterDepartmentIds !== "" && filterDepartmentIds !== undefined ? filterDepartmentIds : departmentId;

  if (roleFunctions.includes(ALL_DEPT)) {
    response = await axiosPrivate.get(
      basicUrl +
        paramStatus +
        paramTagId +
        excludeBot +
        paramUserId +
        paramCampaignIds +
        paramChannelIds +
        paramDepartmentIds +
        paramDate,
    );
  } else if (roleFunctions.includes(OWN_DEPT)) {
    response = await axiosPrivate.get(
      basicUrl +
        `&departmentIds=${ownDepartmentIds}` +
        paramStatus +
        paramTagId +
        excludeBot +
        paramUserId +
        paramCampaignIds +
        paramChannelIds +
        paramDate,
    ); //deptId
  } else if (roleFunctions.includes(OWN)) {
    response = await axiosPrivate.get(
      basicUrl +
        `&userId=${userId}&departmentIds=${ownDepartmentIds}` +
        paramStatus +
        paramTagId +
        excludeBot +
        paramUserId +
        paramCampaignIds +
        paramChannelIds +
        paramDate,
    );
  }
  return response;
};

export const serviceGetChatsOld = async (token, userId, departmentId, status, tagId, roleFunctions) => {
  const basicUrl = `api/chats?take=${limit}&order=DESC`;
  axiosPrivate.interceptors.request.use((config) => {
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  });
  let paramStatus = "";
  let paramTagId = "";
  if (status !== "") {
    paramStatus = "&status=" + status;
  }
  if (tagId !== "" && tagId !== undefined) {
    paramTagId = "&tagIds=" + tagId;
  }
  let response = null;

  if (roleFunctions.includes(ALL_DEPT)) {
    response = await axiosPrivate.get(basicUrl + paramStatus + paramTagId);
  } else if (roleFunctions.includes(OWN_DEPT)) {
    response = await axiosPrivate.get(
      `api/chats/?departmentId=${departmentId}&take=${limit}&order=DESC` + paramStatus + paramTagId,
    ); //deptId
  } else if (roleFunctions.includes(OWN)) {
    response = await axiosPrivate.get(basicUrl + paramStatus + "&userId=" + userId + paramTagId);
  }
  return response;
};

export const serviceGetChatsByAdminStatus = async (token, userId, departmentId, status, tagId, roleFunctions) => {
  const basicUrl = `api/chats?take=${limit}&order=DESC`;
  axiosPrivate.interceptors.request.use((config) => {
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  });
  let paramStatus = "";
  let paramTagId = "";
  if (status !== "") {
    paramStatus = "&adminStatus=" + status;
  }
  if (tagId !== "" && tagId !== undefined) {
    paramTagId = "&tagIds=" + tagId;
  }
  let response = null;
  if (roleFunctions.includes(ALL_DEPT)) {
    response = await axiosPrivate.get(basicUrl + paramStatus + paramTagId);
  } else if (roleFunctions.includes(OWN_DEPT)) {
    response = await axiosPrivate.get(
      basicUrl + `&excludeBot=true&departmentIds=${departmentId}` + paramStatus + paramTagId,
    ); //deptId
  } else if (roleFunctions.includes(OWN)) {
    response = await axiosPrivate.get(basicUrl + paramStatus + "&excludeBot=true&userId=" + userId + paramTagId);
  }
  return response;
};

export const serviceGetChatsPage = async (
  token,
  userId,
  departmentId,
  status,
  tagId,
  page,
  roleFunctions,
  roleName,
  filterUserId,
  campaignIds = "",
  channelIds = "",
  filterDepartmentIds = "",
  dateFrom = "",
  dateTo = "",
) => {
  try {
    const basicUrl = `api/chats?take=${limit}&page=${page || 1}&order=DESC&fo=chat.updatedAt`;
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    let paramStatus = "";
    let paramUserId = "";
    let paramTagId = "";
    let paramCampaignIds = "";
    let paramChannelIds = "";

    if (status) {
      if (status === "CHATBOT" && roleFunctions.includes("View_Chatbot")) {
        paramStatus = "&userId=" + BOT_ID;
      } else {
        paramStatus = "&" + getParamStatus(roleName) + "=" + status;
      }
    }

    if (tagId !== "" && tagId !== undefined) {
      paramTagId = "&tagIds=" + tagId;
    }

    if (filterUserId !== "" && filterUserId !== undefined) {
      paramUserId = "&userId=" + filterUserId;
    }

    if (campaignIds !== "" && campaignIds !== undefined) {
      paramCampaignIds = "&campaignIds=" + campaignIds;
    }

    if (channelIds !== "" && channelIds !== undefined) {
      paramChannelIds = "&channelIds=" + channelIds;
    }

    // CRITICAL: date filter MUST mirror serviceGetChats
    // Without this, load-more drops the active date filter and returns the newest unfiltered page
    let paramDate = "";

    if (dateFrom !== "" && dateFrom !== undefined) {
      paramDate += "&dateFrom=" + dateFrom;
    }

    if (dateTo !== "" && dateTo !== undefined) {
      paramDate += "&dateTo=" + dateTo;
    }

    let response = null;
    let excludeBot = "";

    // CRITICAL: excludeBot MUST be included to match serviceGetChats query
    // Without this, CS/SALES role will get different data between page 1 and page 2
    if (!roleFunctions.includes("View_Chatbot")) {
      excludeBot = "&excludeBot=true";
    }

    // CRITICAL: department filter MUST mirror serviceGetChats
    // Without this, filtered list gets mixed data between page 1 and page 2
    let paramDepartmentIds = "";

    if (filterDepartmentIds !== "" && filterDepartmentIds !== undefined) {
      paramDepartmentIds = "&departmentIds=" + filterDepartmentIds;
    }

    const ownDepartmentIds =
      filterDepartmentIds !== "" && filterDepartmentIds !== undefined ? filterDepartmentIds : departmentId;

    if (roleFunctions.includes(ALL_DEPT)) {
      response = await axiosPrivate.get(
        basicUrl +
          paramStatus +
          paramTagId +
          excludeBot +
          paramUserId +
          paramCampaignIds +
          paramChannelIds +
          paramDepartmentIds +
          paramDate,
      );
    } else if (roleFunctions.includes(OWN_DEPT)) {
      // CRITICAL: MUST use departmentIds (PLURAL) to match serviceGetChats
      // Backend expects departmentIds not departmentId
      response = await axiosPrivate.get(
        basicUrl +
          "&departmentIds=" +
          ownDepartmentIds +
          paramStatus +
          paramTagId +
          excludeBot +
          paramUserId +
          paramCampaignIds +
          paramChannelIds +
          paramDate,
      ); //deptId
    } else if (roleFunctions.includes(OWN)) {
      // CRITICAL: MUST include departmentIds for OWN role too
      response = await axiosPrivate.get(
        basicUrl +
          "&userId=" +
          userId +
          "&departmentIds=" +
          ownDepartmentIds +
          paramStatus +
          paramTagId +
          excludeBot +
          paramUserId +
          paramCampaignIds +
          paramChannelIds +
          paramDate,
      );
    }
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceGetChatById = async (token, chatId) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    const response = await axiosPrivate.get("api/chats/" + chatId);

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceMarkChatSolved = async (token, chatId) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    const response = await axiosPrivate.put("api/chats/" + chatId + "/solve");
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const servicePutAssignChatUser = async (token, chatId, newUserId, data) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    const dataJson = JSON.stringify(data);
    const response = await axiosPrivate.put(
      "api/chats/assign/" + chatId + "/" + newUserId + "/?type=ASSIGN_USER&source=WEB",
      dataJson,
    );

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const servicePutAssignChatBot = async (token, isTakeOver, chatId, newUserId, data) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    // const response = await axiosPrivate.put("api/chats/" + chatId, data);
    const response = await axiosPrivate.put(
      "api/chats/assign/" + chatId + "/" + newUserId + `/?type=${isTakeOver ? "TAKE_OVER" : "ASSIGN_BOT"}&source=WEB`,
      data,
    );

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const servicePutAssignTag = async (token, chatTags) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    const response = await axiosPrivate.put("api/chats/tags", chatTags);
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceResetTag = async (token, chatTags) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    const response = await axiosPrivate.put("api/chats/tags/reset", chatTags);
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceGetFilterChat = async (
  token,
  role,
  query,
  userId,
  departmentId,
  roleFunctions,
  status,
  filterUserId = "",
  tagIds = "",
  campaignIds = "",
  filterDepartmentIds = "",
  dateFrom = "",
  dateTo = "",
) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    let response = null;
    let paramStatus = "";

    if (status) {
      if (status.toUpperCase() === "CHATBOT") {
        paramStatus = `&userId=${BOT_ID}`;
      } else {
        paramStatus = "&" + getParamStatus(role) + "=" + status.toUpperCase();
      }
    }

    const orderParam = "&order=DESC&fo=chat.updatedAt";

    let paramFilterUserId = "";
    if (filterUserId !== "" && filterUserId !== undefined) {
      paramFilterUserId = "&userId=" + filterUserId;
    }

    let paramTagIds = "";
    if (tagIds !== "" && tagIds !== undefined) {
      paramTagIds = "&tagIds=" + tagIds;
    }

    let paramCampaignIds = "";
    if (campaignIds !== "" && campaignIds !== undefined) {
      paramCampaignIds = "&campaignIds=" + campaignIds;
    }

    let paramFilterDepartmentIds = "";
    if (filterDepartmentIds !== "" && filterDepartmentIds !== undefined) {
      paramFilterDepartmentIds = "&departmentIds=" + filterDepartmentIds;
    }

    let paramDate = "";
    if (dateFrom !== "" && dateFrom !== undefined) {
      paramDate += "&dateFrom=" + dateFrom;
    }
    if (dateTo !== "" && dateTo !== undefined) {
      paramDate += "&dateTo=" + dateTo;
    }

    const filterParams = paramFilterUserId + paramTagIds + paramCampaignIds + paramFilterDepartmentIds + paramDate;

    if (roleFunctions.includes("Access_Own")) {
      response = await axiosPrivate.get(
        "api/chat-searches?userId=" + userId + "&limit=30&q=" + query + paramStatus + orderParam + filterParams,
      );
    } else if (roleFunctions.includes("Access_Own_Dept")) {
      response = await axiosPrivate.get(
        "api/chat-searches?&limit=30&q=" + query + paramStatus + orderParam + filterParams,
      );
    } else {
      response = await axiosPrivate.get(
        "api/chat-searches?&limit=30&q=" + query + paramStatus + orderParam + filterParams,
      );
    }

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

/*

export const serviceGetChatsByName = async (token, userId, status, name,roleFunctions) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    let paramStatus = "";
    if(status !== ""){
      paramStatus = "&status="+status;
    }
    let paramName = "";
    if(name !== ""){
      paramName = `&q=name like '%${name}%'`;
    }
    const response = await axiosPrivate.get("api/chats?take=15&order=DESC" + paramStatus +"&userId="+userId + paramName);

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceGetChatsByText = async (token, userId, status, text,roleFunctions) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    let paramStatus = "";
    if(status !== ""){
      paramStatus = "&status="+status;
    }
    let paramText = "";
    if(text !== ""){
      paramText = `&q=text like '%${text}% and user_id='${userId}'`;
    }
    const response = await axiosPrivate.get("api/messages?take=15&order=DESC" + paramStatus + paramText);

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};
*/
